import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddQuestionModalComponent } from "./add-question-modal.component";
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { SearchCoreModule } from '../search-core/search-core.module';
import { SortV2Module } from '../sort-v2/sort-v2.module';
import { FilterV2Module } from '../filter-v2/filter-v2.module';
import { SurveyBuilderHelpContentModule } from '../survey-builder-help-content/survey-builder-help-content.module';
import { SearchInteriorModule } from '../search-interior/search-interior.module';
import { QuestionFilterComponent } from './components/question-filter/question-filter.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { QuestionComponent } from './components/question/question.component';
import { SortByPipeModule } from 'src/app/pipes/sort-pipe/sort-by.module';
import {LoaderModule} from "src/app/components/loader/loader.module";
import {
  ButtonModule,
  TagsModule,
  GroupDropdownModule,
  CheckboxModule,
  KebabMenuModule,
  TooltipModule,
  ToggleModule
} from '@xref/xref-lib';
import { LockedFeatureModalModule } from '../locked-feature-modal/locked-feature-modal.module';

@NgModule({
  declarations: [AddQuestionModalComponent, QuestionFilterComponent, QuestionComponent],
  imports: [
    CommonModule,
    FormsModule,
    SearchCoreModule,
    SearchInteriorModule,
    SortV2Module,
    FilterV2Module,
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    SurveyBuilderHelpContentModule,
    SortByPipeModule,
    TagsModule,
    GroupDropdownModule,
    CheckboxModule,
    KebabMenuModule,
    ButtonModule,
    ToggleModule,
    TooltipModule,
    LoaderModule,
    LockedFeatureModalModule
  ],
  exports: [AddQuestionModalComponent]
})
export class AddQuestionModalModule { }
